import { createFileRoute } from "@tanstack/react-router";
import { Installation } from "@/features/settings/installation";

export const Route = createFileRoute("/settings/installation")({
  component: Installation,
});
